import FAQPage from './FAQPage.jsx';

export {
  FAQPage
}


// WEBPACK FOOTER //
// ./pages/faq/index.js